import { Icon, Typography } from "@mui/material";
import React from "react";
import { Card } from "react-bootstrap";
import RpSvgIcon from "@/components/icons/RpSvgIcon";
import { getImage } from "@/helpers/utils";

const BootstrapCard = Card as React.ElementType;

type ContractDetails = {
  fileName?: string;
  label?: string;
  fileSize?: string | number;
  value?: string;
};

const ContractDetailsCard = ({
  contractDetails,
}: {
  contractDetails?: ContractDetails;
}) => {
  const downloadFile = (fileURL?: string, fileName?: string) => {
    if (!fileURL) {
      alert("Download link not available");
      return;
    }

    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", fileName || "download");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileType = (name) =>
    name.endsWith(".docx") ? "DOCX" : name.endsWith(".pdf") ? "PDF" : "";

  return (
    <div className="brand-info-card-wrapper pl-2">
      <Typography color="text.primary" className="grid-title">
        Contract Details
      </Typography>
      <BootstrapCard className="brand-info-card contract-details-card">
        <div className="h-100 d-flex align-items-center">
          <div className="d-flex">
            <div className="h-100 d-flex align-items-center justify-content-center text-center">
              <Icon
                component={RpSvgIcon}
                name="file_icon"
                color="primary"
                size="large"
                style={{ width: 76, height: 76 }}
                className="mr-3"
              />
            </div>
            <div className="ml-2">
              <div className="mb-2 contract-name text-break">
                {contractDetails?.fileName
                  ? contractDetails?.fileName
                  : contractDetails?.label}
              </div>
              <div className="text-muted mt-2 file-info">
                {contractDetails?.fileSize
                  ? `${getFileType(contractDetails?.fileName ? contractDetails?.fileName : "")} - ${contractDetails.fileSize} MB`
                  : "N/A"}
              </div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadFile(
                    getImage(contractDetails?.value, "ASSET_DOWNLOAD_URL"),
                    contractDetails?.fileName
                  );
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="primary text-decoration-none download-link"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      </BootstrapCard>
    </div>
  );
};

export default ContractDetailsCard;
